import React, { useState } from "react";

import {
  Stack,
  Dialog,
  DialogContent,
  Typography,
  Divider,
  IconButton,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Chip,
  DialogTitle,
} from "@mui/material";
import { toast } from "react-toastify";

import InstagramIcon from "@mui/icons-material/Instagram";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import HelpCenterRoundedIcon from "@mui/icons-material/HelpCenterRounded";

export const HelpChip = () => {
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <div>
      <ListItemButton onClick={handleOpenModal}>
        <ListItemIcon>
          <HelpCenterRoundedIcon />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography flex={1} variant="body2" sx={{ fontWeight: 600 }}>
              Contact us
            </Typography>
          }
        />
      </ListItemButton>

      <Dialog open={openModal} onClose={handleCloseModal} fullWidth>
        <DialogTitle>Contact us</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            <Stack spacing={1}>
              <Typography>
                Thank you for supporting us in our early days. Your feedback has
                truly helped shape our platform, and we’re grateful for your
                trust.
              </Typography>
              <Typography>
                If you ever need help or have suggestions, we’re always here for
                you. Thanks again for being part of our journey—we look forward
                to growing with you.
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1}>
              <Chip
                icon={<InstagramIcon />}
                label="Instagram"
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/flowly.cookies/",
                    "_blank"
                  )
                }
              />
              <Chip
                icon={<AlternateEmailIcon />}
                label="admin@flowlyapp.com"
                onClick={() => {
                  navigator.clipboard.writeText("admin@flowlyapp.com");
                  toast(`Email copied.`, {
                    position: "bottom-center",
                    autoClose: 800,
                  });
                }}
              />
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
};
